import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import CasinoChatTawkContent from './CasinoChatTawkContent';

export default function CasinoChatTawk() {
  return (
    <CasinoContainer title={'Online chat tawk.io for'}>
      <CasinoChatTawkContent />
    </CasinoContainer>
  );
}
